module.exports = __webpack_public_path__ + "static/aboutus-4.4f789090.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutus/aboutus-4.svg
// module id = 1085
// module chunks = 4035221647099